import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormFields } from '../../../components/UpsertInsuranceModal/UpsertInsuranceModal.meta';
import { InputNumberMask } from '../../../../../CommonComponents/OPL/Input/InputNumberMask';

export const DisabilityMonthlyBenefitAmount = () => {
  const formBag = useFormContext<FormFields>();

  return (
    <Controller
      control={formBag.control}
      name="DisabilityMonthlyBenefitAmount"
      render={({ field: { onChange, ...field } }) => (
        <InputNumberMask
          {...field}
          label="Monthly Benefit Amount"
          decimalScale={2}
          allowNegative={false}
          leftIcon="far fa-dollar-sign"
          maxLength={14}
          onValueChange={({ floatValue }) => {
            onChange(floatValue ?? null);
          }}
        />
      )}
    />
  );
};
